$(document).ready(function () {
  //confirm before enter checkout button
  $(document).on('change', '#confirm_checkout', function() {
    const isChecked = $('#confirm_checkout').prop('checked');    
    $('.product__checkout-trigger__modal').prop('disabled', !isChecked);
  });

  $(".product__checkout-trigger__modal").on("click", function() {
    $(".confirm-marketing-email").prop('checked', false);
    $('#checkout').prop('disabled', true);
  });

  //only 1 checked checkbox before submit
  $('.confirm-marketing-email').on('change', function() {
    $('.confirm-marketing-email').not(this).prop('checked', false);

    const isChecked = $('.confirm-marketing-email:checked').length > 0;
    $('#checkout').prop('disabled', !isChecked);
  });
});